<template>
  <svg
    :width="width"
    :height="height"
    viewBox="0 0 50 50"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle
      cx="25"
      cy="25"
      r="24"
      fill="white"
      stroke="#006EFF"
      stroke-width="2"
    />
    <path
      d="M14 25.5882L21.6154 33L36 19"
      stroke="#006EFF"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>

<script>
export default {
  props: {
    width: { type: [Number, String], default: 21 },
    height: { type: [Number, String], default: 21 },
    color: { type: String, default: "#80b7ff" },
  },
};
</script>
